import { STATICS } from 'statics'

export const ARROW_DIRECTION_ICON = {
  PREV: <STATICS.ARROW_PREVIOUS />,
  NEXT: <STATICS.ARROW_NEXT />,
}
